import { createFileRoute } from '@tanstack/react-router';
import { FlatfinderToolsPage } from '@/features/flatfinder/tools-page';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/flatfinders')({
  component: FlatfinderToolsPage,
});
